<template>
    <div class="mt-3">
        <SubStepHeader
            :title="qualityForm.title"
            :selectedValue="selectedQualityLabel"
            :contentHidden="qualityHidden"
            @toggle-content="toggleQuality"
        />
        <v-expand-transition>
            <div  v-if="!qualityHidden">
                <StepBtnGroup
                    class="mt-2 step-group "
                    :fields="qualityFields"
                    :selectedValue="selectedValue.quality"
                    :orientation="'column'"
                    :layout="'full-width'"
                    :hasHelpPopUp="true"
                    :helpImage="qualityForm.helpImage"
                    @select-value="selectQuality"
                />
                <StepSaveByDefaultCheckbox 
                    :selectedOption="selectedValue.quality" 
                    :stepId="qualityForm.id"
                    :label ="$t('habiteoStudio.saveQualityByDefault')"
                />
            </div>
        </v-expand-transition>

        <!-- PRESET FORM -->
        <SubStepHeader
            :title="presetData.title"
            :selectedValue="selectedPresetValue"
            :contentHidden="presetHidden"
            @toggle-content="togglePreset"
        />
        <v-expand-transition>
            <div v-if="!presetHidden">
                <StepBtnGroup
                    class="mt-6 step-group format"
                    :fields="presetsfields"
                    :selectedValue="selectedValue.preset"
                    :orientation="'column'"
                    :layout="'full-width'"
                    :hasHelpPopUp="true"
                    :showTwobyTwo="true"
                    :helpImage="presetData.helpImage"
                    @select-value="selectPreset"
                />
                <StepSaveByDefaultCheckbox 
                    :selectedOption="selectedValue.preset" 
                    :stepId="presetData.id"
                    :label ="$t('habiteoStudio.savePresetByDefault')"
                />
            </div>
            
        </v-expand-transition>

        <!-- /PRESET SLIDER -->

        <!-- ADVANCED PRESET DIALOG -->
        <v-dialog
            v-model="isOpenDialog"
            width="285"
            class="my-custom-dialog"
            :attach="true"
            hide-overlay
        >
            <v-card class="pa-8">
                <v-card-title class="pa-0 font-weight-bold h2">
                    {{ advancedPreset.title }}
                </v-card-title>

                <v-card-text class="py-6 pa-0">
                    <StepBtnGroup
                        class="my-6 step-group advanced-preset"
                        :fields="panniniFields"
                        :selectedValue="advancedPresetSettings.pannini"
                        :orientation="'row'"
                        @select-value="selectPannini"
                    />

                    <StepSlider
                        :label="fisheye.label"
                        :sublabel="fisheye.sublabel"
                        :min="fisheye.min"
                        :max="fisheye.max"
                        :step="0.05"
                        :defaultValue="advancedPresetSettings.fisheye"
                        @update-slider="selectFisheye"
                    />
                </v-card-text>

                <div class="d-flex justify-end">
                    <v-btn
                        class="green-text darken-2 text-none font-weight-bold text-decoration-underline pa-2"
                        :elevation="0"
                        color="transparent"
                        x-large
                        :ripple="false"
                        @click.prevent="toggleDialog"
                    >
                        <span>
                            {{ $t('utils.validate') }}
                        </span>
                    </v-btn>
                </div>
            </v-card>
        </v-dialog>
        <!-- /ADVANCED PRESET DIALOG -->

        <!-- /PRESET FORM -->
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import StepHeader from '@/components/myHabiteoStudio/steps/components/StepHeader';
    import StepRadioGroup from '@/components/myHabiteoStudio/steps/components/StepRadioGroup';
    import StepSlider from "@/components/myHabiteoStudio/steps/components/StepSlider";
    import StepBtn from "@/components/myHabiteoStudio/steps/components/StepBtn";
    import StepBtnGroup from "@/components/myHabiteoStudio/steps/components/StepBtnGroup";
    import StepSaveByDefaultCheckbox from '@/components/myHabiteoStudio/steps/components/StepSaveByDefaultCheckbox';
    import SubStepHeader from '@/components/myHabiteoStudio/steps/components/SubStepHeader';


    export default {
        name: 'StepQuality',
        components: {
            StepBtnGroup,
            StepSlider,
            StepHeader,
            StepRadioGroup,
            StepBtn,
            StepSaveByDefaultCheckbox,
            SubStepHeader
        },
        props: {
            subtitle: {
                type: String,
                required: true
            },
            forms: {
                type: Array,
                required: true
            },
            selectedValue: {
                type: Object,
                required: false
            },
            defaultQuality: {
                type: String,
                required: false
            },
            defaultsPresetValues: {
                type: String,
                required: false
            }
        },
        computed: {
            ...mapGetters([
                'isLocalstorageAvailable'
            ]),
            qualityForm() {
                return this.$props.forms.find(el => el.id === 'quality');
            },
            qualityFields() {
                return this.qualityForm.inputs[0].fields;
            },
            pannini() {
                return this.advancedPreset.fields.find(el => el.id === 'panini');
            },
            fisheye() {
                return this.advancedPreset.fields.find(el => el.id === 'fisheye');
            },
            presetsfields() {
                return this.presetData.inputs.find(el => el.id === 'preset').fields;
            },
            presetData() {
                return this.$props.forms.find(el => el.id === 'preset');
            },
            advancedPreset() {
                return this.presetData.inputs.find(el => el.id === 'advanced_preset');
            },
            advancedPresetKey() {
                return `advanced-preset-${this.$route.query.id}`;
            },
            advancedPresetSettings() {
                return {
                    'pannini': this.selectedPannini,
                    'fisheye': this.selectedFisheye
                };
            },
            isLowResolution() {
                return this.qualityForm.disclaimer === true;
            },
            selectedQuality() {
                return this.selectedValue.quality ? this.qualityForm.inputs[0].fields.find(el => el.value === this.selectedValue.quality) : null;
            },
            selectedQualityLabel() {
                return this.selectedQuality ? " : " + this.selectedQuality.label : "";
            },
            selecledPreset() {
                return this.selectedValue.preset ? this.presetData.inputs[0].fields.find(el => el.value === this.selectedValue.preset) : null;
            },
            selectedPresetValue() {
                return this.selecledPreset ? " : " + this.selecledPreset.label : "";
            }
        },
        data() {
            return {
                isOpenDialog: false,
                selectedPreset: null,
                selectedPannini: null,
                selectedFisheye: null,
                panniniFields: [],
                qualityHidden: true,
                presetHidden: true,
                presetStorageKey: `myHabiteo-studio-step-preset`,
                qualityStorageKey: `myHabiteo-studio-step-quality`
            }
        },
        mounted() {
            if (this.isLocalstorageAvailable) {
                this.selectedPannini = localStorage.getItem(this.advancedPresetKey) ? JSON.parse(localStorage.getItem(this.advancedPresetKey)).pannini : 0;
                this.selectedFisheye = localStorage.getItem(this.advancedPresetKey) ? JSON.parse(localStorage.getItem(this.advancedPresetKey)).fisheye : 0.5;
                const qualityStorageValue = localStorage.getItem(this.qualityStorageKey) ? JSON.parse(localStorage.getItem(this.qualityStorageKey)) : null;
                const presetStorageValue = localStorage.getItem(this.presetStorageKey) ? JSON.parse(localStorage.getItem(this.presetStorageKey)) : null;
                this.qualityForm.inputs[0].value = this.qualityForm.inputs[0].value || qualityStorageValue || this.$props.forms[0].inputs[0].fields.find(el => el.id === this.$props.defaultQuality).value;
                this.presetData.inputs[0].value = this.presetData.inputs[0].value || presetStorageValue || this.$props.forms[1].inputs[0].fields.find(el => el.id === this.$props.defaultsPresetValues).value;
            }
            this.getPanniniField();
        },
    methods: {
            togglePreset() {
                this.presetHidden = !this.presetHidden;
            },
            selectQuality (quality) { 
                this.qualityForm.inputs[0].value = quality;
            },
            selectPreset (preset) { 
                this.presetData.inputs[0].value = preset ;
            },
            toggleQuality () { 
                this.qualityHidden = !this.qualityHidden; 
            },
            toggleDialog() {
                this.isOpenDialog = !this.isOpenDialog;
            },
            getPanniniField() {
                let verticalPanniniObject = {
                    'label': this.pannini.label,
                    'value': this.pannini.min
                }
                let horizontalPanniniObject= {
                    'label': this.pannini.sublabel,
                    'value': this.pannini.max
                }
                this.panniniFields.push(verticalPanniniObject);
                this.panniniFields.push(horizontalPanniniObject);
            },
            selectPannini(value) {
                this.selectedPannini = value;
                if (this.isLocalstorageAvailable)
                    this.saveAdvancedPresetSettings();
                this.$emit('set-properties', 'pannini', value);
            },
            setProperties(type, value) {
                this.$emit('set-properties', type, value);
            },
            selectFisheye(value) {
                this.selectedFisheye = value;
                if (this.isLocalstorageAvailable)
                    this.saveAdvancedPresetSettings();
                this.$emit('set-properties', 'fisheye', value);
            },
            saveAdvancedPresetSettings() {
                localStorage.setItem(this.advancedPresetKey, JSON.stringify({
                    'pannini': this.selectedPannini,
                    'fisheye': this.selectedFisheye
                }));
            },
            
        },
        watch: {
            selectedPreset(val) {
                this.presetData.inputs[0].value = val + 1;
            },
            selectedPannini(val) {
                this.presetData.inputs[1].value = {
                    'pannini': val,
                    'fisheye': this.selectedFisheye
                };
            },
            selectedFisheye(val) {
                this.presetData.inputs[1].value = {
                    'pannini': this.selectedPannini,
                    'fisheye': val
                };
            }
        }
    }
</script>

<style lang="scss">
    @import "@/assets/scss/components/_slider-group.scss";
</style>


// WEBPACK FOOTER //
// src/components/myHabiteoStudio/steps/StepQuality.vue